/**
 * @generated SignedSource<<f91e893f773d12da92fc39e3d58b2123>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LockedEventViewer$data = {
  readonly repository: {
    readonly owner: {
      readonly " $fragmentSpreads": FragmentRefs<"EventActor" | "EventActorAvatarItemBadge">;
    };
    readonly viewerCanPush: boolean;
  };
  readonly " $fragmentType": "LockedEventViewer";
};
export type LockedEventViewer$key = {
  readonly " $data"?: LockedEventViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"LockedEventViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LockedEventViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanPush",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventActor"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventActorAvatarItemBadge"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "0c0eb9b2c0275074d3d3be0644142f1f";

export default node;
